var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Datepicker',{attrs:{"language":_vm.ja,"format":_vm.customFormatter,"clearButton":_vm.clearButton,"value":_vm.value},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }